import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { IHowHoverWorksCaseStudy } from '../interfaces/IHowHoverWorksCaseStudy';

const HOW_HOVER_WORKS_CASE_STUDIES_DATA: IHowHoverWorksCaseStudy[] = [
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="moral family"
        src="..//assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 0,
  },
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="moral family"
        src="../assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 1,
  },
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="moral family"
        src="../assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 2,
  },
];

export default HOW_HOVER_WORKS_CASE_STUDIES_DATA;
